import { render, staticRenderFns } from "./ArtistAndSongForm.vue?vue&type=template&id=7740fc0f&scoped=true&"
import script from "./ArtistAndSongForm.vue?vue&type=script&lang=ts&"
export * from "./ArtistAndSongForm.vue?vue&type=script&lang=ts&"
import style0 from "./ArtistAndSongForm.vue?vue&type=style&index=0&id=7740fc0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740fc0f",
  null
  
)

export default component.exports